export const IS_PRIVATE_FINANCING_ENABLED = true

export const FARE_ID = {
  BMW_BANK_MULTI_BRAND_FARE_ID: '65',
  MOBILIZE_NISSAN_NSFS_FARE_ID: '68',
  MOBILIZE_NISSAN_NSFS_WITH_PROMOTION_FARE_ID: '71'
}

export const FINANCING_PARTNERS = {
  BBVA: 'bbva',
  BBVA_WITHOUT_INSURANCE: 'bbva-without-insurance',
  BMW_BANK: 'bmw-bank',
  BMW_BANK_MULTI_BRAND: 'bmw-bank-multi-brand',
  COFIDIS: 'cofidis',
  SANTANDER: 'santander',
  SANTANDER_PRI: 'santander-pri',
  SANTANDER_WITH_CASUALTY_INSURANCE: 'santander-with-casualty-insurance',
  SANTANDER_WITHOUT_INSURANCE: 'santander-without-insurance',
  CAIXA: 'caixa',
  LENDROCK: 'lendrock',
  MOBILIZE: 'mobilize',
  MOBILIZE_NISSAN: 'mobilize-nissan',
  MOBILIZE_NISSAN_NSFS: 'mobilize-nissan-nsfs',
  STELLANTIS: 'stellantis',
  VWFS: 'vwfs',
  CONFIA: 'confia'
}

export const LENDERS_DICTIONARIES = {
  [FINANCING_PARTNERS.BBVA]: {
    id: FINANCING_PARTNERS.BBVA,
    name: 'COMMON.FINANCING_INFO.LENDERS.BBVA.NAME'
  },
  [FINANCING_PARTNERS.BMW_BANK]: {
    id: FINANCING_PARTNERS.BMW_BANK,
    name: 'COMMON.FINANCING_INFO.LENDERS.BMW_BANK.NAME'
  },
  [FINANCING_PARTNERS.SANTANDER]: {
    id: FINANCING_PARTNERS.SANTANDER,
    name: 'COMMON.FINANCING_INFO.LENDERS.SANTANDER.NAME'
  },
  [FINANCING_PARTNERS.CAIXA]: {
    id: FINANCING_PARTNERS.CAIXA,
    name: 'COMMON.FINANCING_INFO.LENDERS.CAIXA.NAME'
  },
  [FINANCING_PARTNERS.LENDROCK]: {
    id: FINANCING_PARTNERS.LENDROCK,
    name: 'COMMON.FINANCING_INFO.LENDERS.LENDROCK.NAME'
  },
  [FINANCING_PARTNERS.MOBILIZE]: {
    id: FINANCING_PARTNERS.MOBILIZE,
    name: 'COMMON.FINANCING_INFO.LENDERS.MOBILIZE.NAME'
  },
  [FINANCING_PARTNERS.MOBILIZE_NISSAN]: {
    id: FINANCING_PARTNERS.MOBILIZE_NISSAN,
    name: 'COMMON.FINANCING_INFO.LENDERS.MOBILIZE_NISSAN.NAME'
  },
  [FINANCING_PARTNERS.STELLANTIS]: {
    id: FINANCING_PARTNERS.STELLANTIS,
    name: 'COMMON.FINANCING_INFO.LENDERS.STELLANTIS.NAME'
  },
  [FINANCING_PARTNERS.VWFS]: {
    id: FINANCING_PARTNERS.VWFS,
    name: 'COMMON.FINANCING_INFO.LENDERS.VWFS.NAME'
  },
  [FINANCING_PARTNERS.CONFIA]: {
    id: FINANCING_PARTNERS.CONFIA,
    name: 'COMMON.FINANCING_INFO.LENDERS.CONFIA.NAME'
  }
}

export const LENDERS_LEGAL_CONDITIONS = [
  'bbva',
  'bmw-bank',
  'bmw-bank-multi-brand',
  'santander',
  'santander-pri',
  'caixa',
  'lendrock',
  'mobilize',
  'mobilize-nissan',
  'mobilize-nissan-nsfs',
  'stellantis',
  'vwfs',
  'confia'
]

export const INSURANCE_IDS = {
  COFIDIS_WITHOUT_INSURANCE: '1',
  COFIDIS_WITH_LIFE_INSURANCE: '2',
  COFIDIS_WITH_LIFE_PLUS_INSURANCE: '3',
  NO_INSURANCE: '7',
  SANTANDER_WITH_LIFE_INSURANCE: '8',
  CASUALTY: '9',
  CAIXA_WITHOUT_INSURANCE: '12',
  CAIXA_WITH_LIFE_INSURANCE: '13',
  SANTANDER_PRI_WITHOUT_INSURANCE: '14',
  LENDROCK_WITHOUT_INSURANCE: '15',
  PAYMENT_PROTECTION: '16',
  VWFS_WITH_INSURANCE: '17',
  MOBILIZE_WITH_LIFE_INSURANCE: '18',
  STELLANTIS_WITH_CPI_INSURANCE: '19',
  STELLANTIS_WITH_CPI_CASUALTY_INSURANCE: '20',
  STELLANTIS_WITH_SC_INSURANCE: '21',
  STELLANTIS_WITH_SC_INSURANCE_1: '22',
  WITHOUT_INSURANCE_BBVA: '23',
  PPP_BBVA: '24',
  BMW_BANK: '25',
  MOBILIZE_NISSAN_WITH_LIFE_INSURANCE: '26',
  CONFIA_WITH_LIFE_INSURANCE: '27',
  CONFIA_WITHOUT_INSURANCE: '28',
  STELLANTIS_WITH_SC_GMP_SA_INSURANCE: '29'
}

// This is a temporary flag to enable/disable the financing panel for private sellers
// It should be removed along with the code when a final decision is made about PDA
export const HAS_FINANCING_PRI_ENABLED = false

export const RESERVATION_STATUSES = {
  NON_RESERVABLE: 'non_reservable',
  OTHER_RESERVATION: 'other_reservation',
  OWN_PRE_RESERVATION: 'own_pre_reservation',
  OWN_RESERVATION: 'own_reservation',
  OWN_RESERVATION_PENDING_PHONE: 'own_reservation_pending_phone',
  RESERVABLE: 'reservable'
}

export const URL_INSURANCE_INFO_LIFE_PLUS = 'https://s.ccdn.es/documents/coches-net-PRO/transaction/vidaplus.pdf'
export const URL_INSURANCE_INFO_GAP = 'https://s.ccdn.es/documents/coches-net-PRO/transaction/vidaplusgap.pdf'
